import {isDecimal} from 'utils/is-decimal';

export const getFormattedAmountWithCurrency = (amount: number, currency: string) => {
    if (isDecimal(amount)) return `${amount.toFixed(2)} ${currency}`;

    return `${amount} ${currency}`;
};